import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { media, TransitionMixin } from '../components/helpers';

const HomeSlideWrap = styled.div`
	max-height: 90vh;
	overflow: hidden;

	a {
		text-decoration: none;
	}

	.caption {
		width: 100%;
		${TransitionMixin('.25s')};
		opacity: 0;
		max-width: 550px;
		transform: translateY(100%);
		padding: 20px 20px 40px;
		${media.medium`top: 20vh; left: 5vw; position: absolute; padding: 0;`};
		${media.large`top: 20vh; left: 12vw; `};
		&.active {
			opacity: 1;
			transform: translateY(0);
		}
		h1 {
			color: #fff;
			margin: 0px;
			font-size: 30px;
			${media.medium`font-size: 50px;`};
			${media.large`font-size: 70px;`};
		}

		p {
			color: #fff;
			line-height: 28px;
			font-size: 15px;
			letter-spacing: 1px;
			padding-left: 2px;

			${media.medium`font-size: 19px;`};
		}
	}
`;

const BasicSlideWrap = styled.div`
	background: #000;
`;

export const HomeSlide = ({ slide }) => {
	console.log(slide);
	const { sizes } = slide.node.featured_media.localFile.childImageSharp;

	return (
		<HomeSlideWrap>
			<a href={slide.node.acf.site_url} target="_blank">
				<Img sizes={sizes} />
				<div className="caption">
					<h1>{slide.node.title}</h1>
					<p>{slide.node.acf.brand_caption}</p>
				</div>
			</a>
		</HomeSlideWrap>
	);
};

export const BasicSlide = ({ slide }) => {
	console.log(slide);
	const { sizes } = slide.slide_image.localFile.childImageSharp;

	return (
		<HomeSlideWrap>
			<Img sizes={sizes} />
		</HomeSlideWrap>
	);
};

class HomeSlider extends React.Component {
	componentDidMount() {
		document.querySelector('.slick-current .caption').classList.add('active');
		console.log('booming');
	}
	render() {
		var settings = {
			dots: true,
			infinite: true,
			speed: 500,
			arrows: false,
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			beforeChange: () => {
				document
					.querySelector('.slick-current .caption')
					.classList.remove('active');
			},
			afterChange: (currentIndex, nextIndex) => {
				document
					.querySelector('.slick-current .caption')
					.classList.add('active');
			}
		};

		const { slides } = this.props;
		console.log(slides);
		return (
			<Slider {...settings}>
				{slides.map(slide => {
					if (
						slide.node.categories &&
						slide.node.categories[0].name == 'Home'
					) {
						return <HomeSlide key={slide.node.id} slide={slide} />;
					}
				})}
			</Slider>
		);
	}
}

class BasicSlider extends React.Component {
	render() {
		var settings = {
			dots: true,
			infinite: true,
			speed: 500,
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autplaySpeed: 1000
		};

		const { slides } = this.props;
		console.log(slides);
		return (
			<Slider {...settings}>
				{slides.map(slide => {
					return <BasicSlide key={slide.slide_image.id} slide={slide} />;
				})}
			</Slider>
		);
	}
}

export { BasicSlider, HomeSlider };



// WEBPACK FOOTER //
// ./src/components/Sliders.js